import { showToast } from "#root/components/GlobalToaster";
import { useCreateGeneralContact } from "#root/queries/generalContacts";
import ContactForm, { ContactFormData } from "../ContactForm";
import { Breadcrumbs } from "#root/components/Breadcrumbs";
import { useState, useRef } from "react";
import { withOfflineSupport } from "#root/utils/offlineWrapper";
import { OFFLINE_OPERATIONS } from '#root/utils/offlineOperations';
import { useGeneralContactOperations } from '#root/hooks/useGeneralContactOperations';

const AddContact: React.FC = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formKey, setFormKey] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);
    const generalContactOperations = useGeneralContactOperations();

    const handleSubmit = async (contact: ContactFormData, onSuccess?: () => void) => {
        try {
            setIsSubmitting(true);
            await withOfflineSupport({
                operationType: OFFLINE_OPERATIONS.CONTACT.CREATE,
                operationData: contact,
                operations: {
                    generalContactOperations
                },
                metadata: { formData: contact },
                successMessage: 'General contact created successfully',
                onSuccess: () => {
                    setFormKey(prev => prev + 1);
                    containerRef.current?.scrollIntoView({ behavior: 'smooth' });
                    onSuccess?.();
                },
                onQueued: () => {
                    setFormKey(prev => prev + 1);
                    containerRef.current?.scrollIntoView({ behavior: 'smooth' });
                }
            });
        } catch (error) {
            showToast('Failed to create general contact', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="add-contact" ref={containerRef}>
            <div className="emc-page-header">
                <div className="emc-page-header__top-row">
                    <div className="emc-page-header__breadcrumbs">
                        <Breadcrumbs />
                    </div>
                </div>
                <div className="emc-page-header__title">
                    <h2>Add General Contact <div className="divider"></div></h2>
                </div>
            </div>

            <ContactForm
                key={formKey}
                onSubmit={handleSubmit}
                submitButtonText="Add General Contact"
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default AddContact;